"use strict";

var PropTypes = require("prop-types");

var classNames = require("classnames");
var LoggerInstance = require("js-logger").get("GiveAnonymousCheckbox");

var ProjectActions = require("./ProjectActions");
var ProjectConstants = require("./ProjectConstants");
var ProjectStore = require("./ProjectStore");

class GiveAnonymousCheckbox extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			isAnonymous: ProjectStore.get("isAnonymous")
		};

		this._onChange = this._onChange.bind(this);
	}

	handleRecurringAnonymousChange(event) {
		var checked = event.target.checked;

		ProjectActions.setAnonymous(checked);
	}

	_onChange() {
		this.setState(ProjectStore.getState());
	}

	componentWillMount() {
		var isAnonymous = this.state.isAnonymous;

		if (ProjectStore.get("isAnonymous") !== isAnonymous) {
			ProjectActions.setAnonymous(isAnonymous);
		}
	}

	componentDidMount() {
		if (this.props.isDesignMode) {
			//To add or remove react components from window, edit wwwroot\js\designer\ExposedComponents.jsx
			parent.window.ComponentActions.childComponentLoaded(this);
		}
		ProjectStore.addChangeListener(this._onChange);
	}

	componentWillUnmount() {
		ProjectStore.removeChangeListener(this._onChange);

		if (this.props.isDesignMode) {
			//To add or remove react components from window, edit wwwroot\js\designer\ExposedComponents.jsx
			parent.window.ComponentActions.childComponentUnloaded(this);
			ProjectActions.setAnonymous(false);
		}
	}

	render() {
		var isAnonymous = this.state.isAnonymous;

		return (
			<div
				data-react-component-name="GiveAnonymousCheckbox"
				data-component-id={this.props.dataComponentId}
				style={{display: "inline-block"}}
			>
				<input type="checkbox" checked={isAnonymous} id="giveAnonymousCheckbox" onChange={this.handleRecurringAnonymousChange} />
			</div>
		);
	}
}

GiveAnonymousCheckbox.defaultProps = {};

GiveAnonymousCheckbox.propTypes = {
	isDesignMode: PropTypes.bool,
	project: PropTypes.object
};

module.exports = GiveAnonymousCheckbox;
